import ProjectData from '@/data/ProjectData.ts'

export default [
    new ProjectData("project-1", "Wargaming Simulator 3D", "img/projects/wgs3d.gif", 
    `
    <div class="paragraph">
     Currently in development, <strong>Wargaming Simulator 3D</strong> is a simulator of Real Time Strategy game with a complex mechanism. It's a multiplayer simulator that have classic RTS game with Red vs Blue team but with a dynamic aspect of double platform, the WGS3D only play the outcome of an action that respective team set before in a web app called Wargaming Simulator 2D, hence the name Simulator. 
     <br/>As far as I know, the application still developed and entering the final stage of development</a>.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/e6aYTGAxS_I" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph">
        Main features :
        <ul>
        <li>Local Multiplayer using Colyseus and Socket.IO</li>
        <li>Simulate battle using 3D view, user can control how they see the battle goes on or following automated camera movement</li>
        <li>A lot of real war machine simulator and tactics</li>
        <li>Using the latest equipment of national armies all around the globe</li>
        </ul>
    </div>

    <div class="paragraph center">
    <img class="pc-screenshot" src="img/projects/WGS3D/1.png" alt="Singing Addict Screenshot" />
    <img class="pc-screenshot" src="img/projects/WGS3D/2.png" alt="Singing Addict Screenshot" />
    <img class="pc-screenshot" src="img/projects/WGS3D/3.png" alt="Singing Addict Screenshot" />
    <img class="pc-screenshot" src="img/projects/WGS3D/4.png" alt="Singing Addict Screenshot" />
    `, "#0320fc", true, true),

    new ProjectData("project-2", "Qisah Tomang : Cycle Ends", "img/projects/qisahce.gif", `
    <div class="paragraph">
        <strong>Qisah Tomang: Cycle Ends</strong> is a story-rich RPG. The story is set in an East Asia inspired fantasy world. Fight off the Demon Tomang and its minion and discover the truth behind the Cycle of Hatred and put an end to it.
        <br/>The project itself already entering final stage of development and to be expected released on 2025, but you can enjoy the demo on steam.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/V6ODodszLuA" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">
              <a href="https://store.steampowered.com/app/2227810/Qisah_Tomang_Cycle_Ends/" target="_blank"><img src="img/projects/steam-logo.png" alt="Steam Logo" /></a>
          </div>
    <div class="paragraph">
        Main features :
        <ul>
        <li>JPRG Genre type of game</li>
        <li>Set up your team composition according to your own will</li>
        <li>Deep and Complex Lore</li>
        <li>As it's built on RPGMaker, it's optimized and can run in any devices even microwave</li>
        </ul>
    </div>

    <div class="paragraph center">
    <img class="pc-screenshot" src="img/projects/QisahCE/qisah1.jpg" alt="Qisah Cycle Ends" />
    <img class="pc-screenshot" src="img/projects/QisahCE/qisah2.jpg" alt="Qisah Cycle Ends" />
    <img class="pc-screenshot" src="img/projects/QisahCE/qisah3.jpg" alt="Qisah Cycle Ends" />
    <img class="pc-screenshot" src="img/projects/QisahCE/qisah4.jpg" alt="Qisah Cycle Ends" />
    </div>
    `, "#5a78af"),

    new ProjectData("project-3", "Qisah Tomang : Cycle of Hatred", "img/projects/qisahcoh.gif", `
        <div class="paragraph">
            <strong>Qisah Tomang : Cycle of Hatred</strong> is a game made for itch.io Indie Game Making Contest : Rebirth of 2022. 
            <br/>A Roguelike games where you run through as a very powerful Demon and destroy swarms of enemies. Roguelike games where you run through as a very powerful Demon and destroy swarms of enemies.
        </div>
    
        <div class="paragraph">
            Main features :
            <ul>
            <li>Bullet Hell games that testing your reflex</li>
            <li>Fast-paced action and satisfying gameplay</li>
            <li>Players use the top-down view to get a better view for a better strategy</li>
            </ul>
        </div>
    
        <div class="paragraph">
        <div class="notice">
        Windows build available on <a href="https://qisahstudio.itch.io/qisah-tomang-cycle-of-hatred" target="_blank">itch.io</a>.
        </div>
    </div>
    
        <div class="paragraph center">
            <img class="pc-screenshot" src="img/projects/QisahCOH/qisahcoh1.png" alt="Qisah Cycle of Hatred" />
            <img class="pc-screenshot" src="img/projects/QisahCOH/qisahcoh2.jpg" alt="Qisah Cycle of Hatred" />
            <img class="pc-screenshot" src="img/projects/QisahCOH/qisahcoh3.jpg" alt="Qisah Cycle of Hatred" />
            <img class="pc-screenshot" src="img/projects/QisahCOH/qisahcoh4.jpg" alt="Qisah Cycle of Hatred" />
        </div>
        `, "#383838"),

    new ProjectData("project-4", "RSAR AR", "img/projects/rsar.gif", `
    <div class="paragraph">
    <strong>RSAR Augmented Reality</strong> is a Showcase of the merit of Royal South Australian Regiment in form of a interactable media. The user can scan logos of australian army and it will shown an AR Object that can be interacted using coins and frames. The app itself is already finished development waiting for public release.
    </div>

    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/gT2jBmzJLkI" frameborder="0" allowfullscreen></iframe>
    </div>
    
    <div class="paragraph">
        Main features :
        <ul>
        <li>Smooth animations using Unity Animator and Detailed 3D models</li>
        <li>Video playback control to adjusting the course of videos</li>
        <li>Quick image tracking</li>
        </ul>
    </div>

    <div class="paragraph">
        <div class="notice">
        Android Beta Build is available on <a href="https://drive.google.com/file/d/1AMrbCbGJKRQJr5pWWp-ZVo8OG3lA_ZPL/view?usp=sharing" target="_blank">Here</a>. Make sure your Android OS is up to Android 12.
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/RSAR/1.png" alt="RSAR" />
        <img class="pc-screenshot" src="img/projects/RSAR/2.png" alt="RSAR" />
    </div>
    `, "#fcbe03", false, true),

    new ProjectData("project-5", "Hegemony 2", "img/projects/hegemony2.png", `
        <div class="paragraph">
            Currently Under Development<strong> Hegemony 2</strong> is a direct sequel of it's predecessor, Hegemony. First released as a minecraft mod, now it's on the way to be released with Unreal Engine 5 with the promise of better looks and atmosphere.
        </div>
        <div class="paragraph center">
            <iframe class="youtube" src="https://www.youtube.com/embed/lqW2t_XXg08" frameborder="0" allowfullscreen></iframe>
        </div>
    
        <div class="paragraph">
            Main features :
            <ul>
            <li>An Open World Medieval RPG Games that integrate economics and politics system</li>
            <li>Online Multiplayer using UE Multiplayer Framework</li>
            <li>Smooth Animations</li>
            </ul>
        </div>
    
        <div class="paragraph center">
            <img class="pc-screenshot" src="img/projects/Hegemony2/1.png" alt="Drawing Overload Screenshot" />
            <img class="pc-screenshot" src="img/projects/Hegemony2/2.png" alt="Drawing Overload Screenshot" />
            <img class="pc-screenshot" src="img/projects/Hegemony2/3.png" alt="Drawing Overload Screenshot" />
            <img class="pc-screenshot" src="img/projects/Hegemony2/4.png" alt="Drawing Overload Screenshot" />
        </div>
        `, "#a9fc03", false, true),
];